module.exports = __webpack_public_path__ + "static/media/banana-is-wrong.ffac89fb.mp3";